import { Link } from "react-router-dom";
import { ArrowUpRight, MessageSquare, Star } from "lucide-react";
import { useUI } from "../context/UIContext";
import { CONTACT } from "../lib/site";
import { scrollToEl } from "./SmoothScroll";

const SIZES = {
  md: "px-7 py-3.5 text-xs",
  lg: "px-9 py-4 text-sm",
};

export const RequestQuoteButton = ({
  className = "",
  size = "md",
  testid = "request-quote-btn",
}) => (
  <Link
    to="/contact"
    data-testid={testid}
    onClick={() => setTimeout(() => scrollToEl("#quote-form"), 450)}
    className={`btn-sweep group inline-flex items-center justify-center gap-2 bg-bb-gold text-[#0a0a0a] font-cond font-bold uppercase tracking-widest hover:bg-bb-goldhi transition-colors ${SIZES[size]} ${className}`}
  >
    <span className="relative z-10">Request a Quote</span>
    <ArrowUpRight className="relative z-10 h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Link>
);

export const AskExpertButton = ({
  className = "",
  size = "md",
  variant = "outline",
  testid = "ask-expert-btn",
}) => {
  const { setAskOpen } = useUI();
  const base =
    variant === "outline"
      ? "border border-white/20 text-bb-silver hover:border-bb-gold hover:text-bb-gold"
      : "text-bb-silver hover:text-bb-gold";
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => setAskOpen(true)}
      className={`group inline-flex items-center justify-center gap-2 font-cond font-bold uppercase tracking-widest transition-colors ${base} ${SIZES[size]} ${className}`}
    >
      <MessageSquare className="h-4 w-4" />
      Ask the Expert
    </button>
  );
};

export const LeaveReviewButton = ({
  className = "",
  size = "md",
  testid = "leave-review-btn",
}) => (
  <a
    href={CONTACT.reviewUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-2 border border-white/20 text-bb-silver hover:border-bb-gold hover:text-bb-gold font-cond font-bold uppercase tracking-widest transition-colors ${SIZES[size]} ${className}`}
  >
    <Star className="h-4 w-4" />
    Leave a Review
  </a>
);
